import { asObject } from "../coerce";
import { mapApiItemsToCards } from "./contentCardMapper";
import type {
  LibraryApiResponse,
  LibraryContentData,
} from "../../../@types/portalAluno";

export const mapLibraryResponse = (value: unknown): LibraryContentData => {
  const response = asObject<LibraryApiResponse>(value);
  if (!response) {
    throw new Error("A API retornou uma Biblioteca inválida.");
  }

  return {
    sections: {
      documentos: mapApiItemsToCards(
        response.documentos,
        "biblioteca-documentos"
      ),
      games: mapApiItemsToCards(response.games, "biblioteca-games"),
      multimidia: mapApiItemsToCards(
        response.multimidia,
        "biblioteca-multimidia"
      ),
    },
  };
};
